import * as R from 'ramda'

/**
 * URLのhashの文字列から領域の部分だけを配列で取得する
 * @returns string[] 戻り値の説明
 */
export const getRyoikisFromHash = () => {
  const splitedHashStrings = window.location.hash.split('/')
  if (splitedHashStrings.length >= 2) {
    const connectedRyoikiString = R.toUpper(splitedHashStrings[1])
    return connectedRyoikiString.split('_')
  } else {
    return []
  }
}
/**
 * URLのhashの文字列から年次の部分だけを配列で取得する
 * @returns string[]
 */
export const getNenjiFromHash = () => {
  const splitedHashStrings = window.location.hash.split('/')
  if (splitedHashStrings.length >= 3) {
    const connectedNenjiString = splitedHashStrings[2]
    return connectedNenjiString.split('')
  } else {
    return []
  }
}
